/*
 * Copyright (c) Nexign, JSC, 2022-2025.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.19.0
 */

import useTableFooterButtons, { IUseTableFooterButtons } from './hooks/useTableFooterButtons';
import useTableFooterDisabled from './hooks/useTableFooterDisabled';
import {
    TableFooterButtonContainerStyled,
    TableFooterContainerStyled,
    TableFooterCounterContainerStyled,
    TableFooterLeftContainerStyled,
    TableFooterRightContainerStyled,
    TableFooterFastActionsButtonsStyled,
} from './styled/TableFooterStyled';
import TableFooterItem from './TableFooterItem';
import TableFooterShowMenu from './TableFooterShowMenu';

export type {
    IUseTableFooterButtons,
};

export {
    /* Hooks */
    useTableFooterButtons,
    useTableFooterDisabled,
    /* Components */
    TableFooterItem,
    TableFooterShowMenu,
    /* Styles */
    TableFooterButtonContainerStyled,
    TableFooterContainerStyled,
    TableFooterCounterContainerStyled,
    TableFooterLeftContainerStyled,
    TableFooterRightContainerStyled,
    TableFooterFastActionsButtonsStyled,
};
